// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1bQ3k","disabled":"FileBtn_disabled__o9Oqe","warn":"FileBtn_warn__2NVE9","fade":"FileBtn_fade__13rQv"};